export const LOAD_RESPONSIBLE_CHANGE_OFFERS_STARTED = "LOAD_RESPONSIBLE_CHANGE_OFFERS_STARTED";
export const LOAD_RESPONSIBLE_CHANGE_OFFERS_SUCCEEDED = "LOAD_RESPONSIBLE_CHANGE_OFFERS_SUCCEEDED";
export const LOAD_RESPONSIBLE_CHANGE_OFFERS_FAILED = "LOAD_RESPONSIBLE_CHANGE_OFFERS_FAILED";

export const UPDATE_RESPONSIBLE_OFFERS_STARTED = "UPDATE_RESPONSIBLE_OFFERS_STARTED";
export const UPDATE_RESPONSIBLE_OFFERS_SUCCEEDED = "UPDATE_RESPONSIBLE_OFFERS_SUCCEEDED";
export const UPDATE_RESPONSIBLE_OFFERS_FAILED = "UPDATE_RESPONSIBLE_OFFERS_FAILED";

export const REFRESH_RESPONSIBLE_OFFERS = "REFRESH_RESPONSIBLE_OFFERS";
